import { Breadcrumb } from '@chakra-ui/react'
import TransitionLink from 'app/components/pages/browse/TransitionLink'
import React, { JSX } from 'react'

type Props = {
  items: { url: string; label: string }[]
  startTransition: (callback: () => void) => void
}

const CategoriesBreadcrumbs = ({ items, startTransition }: Props): JSX.Element => {
  return (
    <Breadcrumb.Root marginTop="20px" fontSize="sm" color="gray.500">
      <Breadcrumb.List>
        {items.map((item, index) => (
          <React.Fragment key={item.url}>
            <Breadcrumb.Item key={item.url} _currentPage={{ fontWeight: 'bold' }}>
              <Breadcrumb.Link fontWeight={index === items.length - 1 ? 'bold' : 'normal'}>
                <TransitionLink href={item.url} startTransition={startTransition}>
                  {item.label}
                </TransitionLink>
              </Breadcrumb.Link>
            </Breadcrumb.Item>
            {index !== items.length - 1 && <Breadcrumb.Separator />}
          </React.Fragment>
        ))}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  )
}

export default CategoriesBreadcrumbs
